module.exports = __webpack_public_path__ + "img/background-top.5eb5e320.jpg";